import { useEffect, useState } from 'react'

export const useDebounce = <T>(value: T, delay = 600): T => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value)

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay)
    return () => {
      clearTimeout(timer)
    }
  }, [JSON.stringify(value), delay])

  return debouncedValue
}
